<template>
  <div class="aliplayer-wrap">
    <div id="aliplayer" />
    <div v-if="!showLoading">
      <slot name="cover" :play-end="loadError" />
    </div>
    <div v-else class="video-waiting">
      <van-loading v-show="isWaiting" color="#1989fa">加载中...</van-loading>
    </div>
  </div>
</template>

<script>
import { aliPlayerJs } from '@/utils/util'
export default {
  name: 'AliPlayer',
  props: {
    liveUrl: {
      type: Array,
      default: Array
    },
    type: {
      type: String,
      default: 'live'
    },
    videoUrl: {
      type: Object,
      default: Object
    }
  },
  data() {
    return {
      defaultOptions: {
        id: 'aliplayer',
        source: '',
        isLive: true,
        autoplay: true,
        liveRetry: 0,
        diagnosisButtonVisible: false,
        hlsFrameChasing: true,
        flvFrameChasing: true
      },
      player: null,
      loadError: true,
      isfullscreen: false,
      showLoading: false,
      isWaiting: false,
      retry: 0
    }
  },
  watch: {
    liveUrl: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          aliPlayerJs().then(() => {
            this.initPlayer()
          })
        }
      }
    }
  },
  mounted() {
    aliPlayerJs().then(() => {
      this.initPlayer()
    })
  },
  beforeDestroy() {
    this.player.dispose()
  },
  methods: {
    initPlayer() {
      if (this.type === 'live') {
        // 趣直播
        this.defaultOptions.autoplay = true
        this.defaultOptions.isLive = true
        // 缓冲最多接受30s
        this.defaultOptions.waitingTimeout = 30
        this.defaultOptions.source = this.filterUrl(this.liveUrl, '.m3u8')
        this.player = new window.Aliplayer(this.defaultOptions, player => {
          player.play()
          this.$emit('ready', player.tag)
        })
      } else if (this.type === 'playback') {
        this.defaultOptions.autoplay = false
        this.defaultOptions.isLive = false

        const source = {}
        for (const key in this.videoUrl) {
          for (const childrenKey in this.videoUrl[key]) {
            if (!this.videoUrl[key][childrenKey]) continue
            source[childrenKey] = this.videoUrl[key][childrenKey]
          }
        }

        this.defaultOptions.source = JSON.stringify(source)
        // 回放
        this.player = new window.Aliplayer(this.defaultOptions, player => {
          player.play()
          this.$emit('ready', player.tag)
        })
      }
      this.registerEvent()
    },

    registerEvent() {
      this.player.on('play', () => {
        this.$emit('play')
      })
      this.player.on('timeupdate', () => {
        this.$emit('timeupdate')
      })
      this.player.on('pause', () => {
        this.$emit('pause')
      })
      this.player.on('error', () => {
        this.loadError = true
        this.isWaiting = false
        this.showLoading = false
        this.retry += 1
        this.$emit('error')
        this.reload()
      })
      this.player.on('ended', () => {
        console.log('ended', '==========')
        this.$emit('ended')
      })
      this.player.on('canplay', () => {
        this.$emit('canplay')
      })
      this.player.on('canplaythrough', () => {
        setTimeout(() => {
          this.loadError = false
        }, 500)
        this.$emit('canplaythrough')
      })
      this.player.on('waiting', () => {
        if (this.retry < 1) {
          this.showLoading = true
          this.isWaiting = true
        }
      })
      this.player.on('playing', () => {
        this.isWaiting = false
      })
    },

    reload() {
      if (this.timmer) {
        clearTimeout(this.timmer)
        return
      }
      setTimeout(() => {
        this.player?.loadByUrl(this.defaultOptions.source)
        this.timmer = null
      }, 2000)
    },

    // 获取对应的播放地址
    filterUrl(urls, type) {
      let url = ''
      urls.forEach(item => {
        if (item.indexOf(type) !== -1) {
          url = item
        }
      })
      return url
    }
  }
}
</script>
<style lang="scss" scoped>
.aliplayer-wrap {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  #aliplayer {
    width: 100%;
    height: 100% !important;
    background-color: #000;
    ::v-deep .prism-cc-btn {
      display: none;
    }
    ::v-deep .prism-setting-btn {
      display: none;
    }
    ::v-deep .pause {
      display: block !important;
      z-index: 1;
    }
    ::v-deep .prism-big-play-btn {
      // z-index: 99;
    }
    ::v-deep .prism-info-display {
      box-sizing: border-box;
    }
    ::v-deep .prism-progress-marker {
      height: 18px;
      top: -6px;
    }
    ::v-deep .prism-volume {
      display: none;
    }
  }
}
.video-waiting {
  position: absolute;
  top: 50%;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  align-items: center;
}
</style>
